import { message, notification } from 'antd'
import moment from 'moment'
import allPaths from '../Config/paths'
import { secureApi } from '../Config/api'
import { authToken, removeToken, removeUser } from '../Redux/actions/authActions'
import { removeDevices } from '../Redux/actions/deviceAction'
import { removeVechicles } from '../Redux/actions/vehiclesAction'
import { GET, POST } from './apis'
import { removeOrganizations, setAllOrganizationsData } from '../Redux/actions/organizationActions'
import { clearFilteredVehicles } from '../Redux/actions/filterVehiclesAction'
import { clearDeviceFilter } from '../Redux/actions/filterDevicesAction'
import { clearUserFilter } from '../Redux/actions/filterUsersAction'
import { clearUsersAdminFilter } from '../Redux/actions/usersAdminFilterActions'
import { clearPeopleCounterData } from '../Redux/actions/peopleCounterActions'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { dateFormate, translations } from './constants'
import { elmecLogo } from '../assets/index'

const requiredMessage = (value) => `Please input your ${value}!`

const inputPlace = (value) => `Input your ${value} Here...!`

const setActiveMenu = (path) => path === allPaths.HOME ? 0 : 1

const successMessage = (desc = 'Successfully Complete!') => {
    return message.success(desc)
}

const infoMessage = (desc = 'Successfully Complete!') => {
    return message.info(desc)
}

const errorMessage = (desc = 'Oops Something Went Wrong!') => {
    return message.error(desc)
}

const warningMessage = (desc = 'Warning!') => {
    return message.warning(desc)
}

const successNotification = (message = 'Successfully Complete!') => {
    return notification.success({ message })
}

const errorNotification = (message = 'Oops Something Went Wrong!') => {
    return notification.error({ message })
}

const convertTitle = (val) => {
    val = val || '-'
    return val?.charAt(0)?.toUpperCase() + val?.slice(1)
}

const stringLimiter = (val, limit = 50) => val?.length > limit ? `${val.slice(0, limit)}...` : val

const formatDate = (date) => {
    return date ? moment(date).format('DD/MM/YYYY') : '-'
}

const verifyToken = async (history, dispatch) => {
    try {
        const data = await secureApi.get(GET?.VERIFY_TOKEN)
        // console.log(data, 'data in new refresh')
        if (!data?.success) {
            // dispatch(removeUser())
            // dispatch(removeToken())
            handleLogout(history, dispatch)
            history.push(allPaths?.LOGIN)
            return false

        } else {
            dispatch(authToken(data?.accessToken))
            return true
        }
    } catch (error) {
        // console.log(error, 'error')
        // dispatch(removeUser())
        // dispatch(removeToken())
        // return false
    }
}

const handleLogout = async (history, dispatch) => {
    try {
        dispatch(removeUser())
        dispatch(removeToken())
        dispatch(removeDevices())
        dispatch(removeVechicles())
        dispatch(removeOrganizations())
        dispatch(clearFilteredVehicles())
        dispatch(clearDeviceFilter())
        dispatch(clearUserFilter())
        dispatch(clearUsersAdminFilter())
        dispatch(clearPeopleCounterData())
        // console.log('logout')
        history.push(allPaths?.LOGIN)
    } catch (err) {
        // console.error('Error during logout:', err)
    }
}

const fetchUsers = async ({ setLoading, setUsers, dispatch, authUser, setUserData, organizationId, setUserPercentage }) => {
    // console.log(authUser,'authUser in helper')
    setLoading(true)
    try {
        // const response = await secureApi.get(GET?.GET_USERS)
        const response = await secureApi.get(`${GET.GET_USERS}?organizationId=${organizationId}&role=${authUser.role}`);
        // console.log(response, 'response in helper get')
        if (response?.success === true) {
            const filteredUsers = response?.data
            setUsers(filteredUsers)
            dispatch(setUserData(filteredUsers))
            dispatch(setUserPercentage(response?.percentage || 0))
        }
    }
    catch (err) {
        if (err?.success === false) {
            message.error(err?.message)
        }
    }
    finally {
        setLoading(false)
    }
}

const fetchDevices = async ({ setDevicesData, setDevicePercentage, setTotalDevices, dispatch, setDevices, user, organizationId }) => {
    try {
        const { id: user_id } = user
        // console.log("User ID:", user_id, organizationId)

        const response = await secureApi.get(`${GET?.GET_DEVICES}?user_id=${user_id}&organization_id=${organizationId}`)
        // console.log("Devices API Response:", response)

        if (response?.success === true) {
            const allDevices = response?.data
            const totalDevices = response?.total_devices
            setDevices(allDevices)
            dispatch(setDevicePercentage(response?.percentage))
            dispatch(setDevicesData(allDevices))
            dispatch(setTotalDevices(totalDevices))
        }
        else {
            dispatch(setDevicesData([]))
            dispatch(setDevicePercentage(0))
            dispatch(setTotalDevices(0))
            setDevices([])
            // console.log("API response did not return success:", response)
        }
    } catch (err) {
        // console.error("Error fetching devices:", err)
    }
}

// Display label of a vehicle wherever one is picked from a list: fleets often
// share one model name, so the plate (targa) and the registering number
// (matricola) are shown too — "Vivacity · AB123CD · 4521". Empty parts are
// skipped; undefined when nothing at all is known.
const vehicleLabel = (vehicle) => {
    const clean = (v) => {
        const s = v == null ? '' : String(v).trim()
        return s && !['null', 'undefined', 'NULL'].includes(s) ? s : ''
    }
    const parts = [
        clean(vehicle?.vehicle_name),
        clean(vehicle?.license_plate),
        clean(vehicle?.registering_number),
    ].filter(Boolean)
    return parts.length ? parts.join(' · ') : undefined
}

const fetchVehicles = async ({ setTotalVehicles, setVehiclePercentage, setVechiclesData, dispatch, user, organizationId }) => {
    // console.log(organizationId,'organizationId')
    try {
        const { id: user_id } = user
        // console.log('user_id',user_id)
        // console.log('organizationId',organizationId)
        // const response = await secureApi?.get(`${GET?.GET_VEHICLES}?user_id=${user_id}`)
        const response = await secureApi?.get(`${GET?.GET_VEHICLES}?user_id=${user_id}&organization_id=${organizationId}`)

        // console.log("Vehicles API Response:", response)

        if (response?.success === true) {
            const allVehicles = response?.data
            // console.log(allVehicles, 'allVehicles')
            const totalVehicle = response?.totalVehicles
            dispatch(setVehiclePercentage(response?.percentage))
            dispatch(setVechiclesData(allVehicles))
            dispatch(setTotalVehicles(totalVehicle))
        }
        else {
            // console.warn("API response did not return success:", response)
            dispatch(setVechiclesData([]))
            dispatch(setTotalVehicles(0))
        }
    }
    catch (err) {
        // console.error("Error fetching vehicles:", err)
    }
}

const fetchBusLed = async ({ setBusLedData, setTotalBusLed, dispatch, user, setBusLedAllData, currentPage, pageSize, setLoading, searchQuery, selectedClients }) => {

    try {
        setLoading && setLoading(true)
        const { id: user_id } = user;
        const page = currentPage;
        const limit = pageSize;

        const response = await secureApi?.get(GET?.GET_ALL_BUS_LED, { params: { user_id, page, limit, searchQuery, client_ids: selectedClients?.map(c => c.value) } })

        if (response?.success === true) {
            dispatch(setBusLedData(response?.data));
            dispatch(setBusLedAllData(response?.allData));
            dispatch(setTotalBusLed(response?.total));
        }

    } catch (err) {
        console.error("Error fetching Bus LED:", err);

    } finally {
        setLoading && setLoading(false)
    }
};


const fetchLines = async ({ setAllLines, dispatch }) => {
    try {
        const response = await secureApi?.get(GET?.GET_ALL_LINES)
        if (response?.success === true) {
            if (response?.data?.length) {
                dispatch(setAllLines(response?.data?.map(item => item?.line_code)))
            } else {
                dispatch(setAllLines([]))
            }
        }
        else {
            dispatch(setAllLines([]))
        }
    }
    catch (err) {
        // console.error("Error fetching vehicles:", err)
    }
}
const fetchLinesDirections = async ({ setAllLinesDirections, dispatch }) => {
    try {
        const response = await secureApi?.get(GET?.GET_ALL_LINES_DIRECTION)
        if (response?.success === true) {
            if (response?.data?.length) {
                dispatch(setAllLinesDirections(response?.data?.map(item => item?.direction_code)))
            } else {
                dispatch(setAllLinesDirections([]))
            }
        }
        else {
            dispatch(setAllLinesDirections([]))
        }
    }
    catch (err) {
        // console.error("Error fetching vehicles:", err)
    }
}

const fetchLastWeekData = async (form, dispatch, setFilteredVehicles, setFilters, setTotalSummary, setDateRange, user, organizationId) => {
    try {
        const { id: user_id } = user

        const response = await secureApi?.get(`${GET?.GET_REPORT}?user_id=${user_id}&organization_id=${organizationId}`)
        if (response?.success) {
            let sortedData = response?.data?.records?.sort((a, b) => {
                const dateComparison = new Date(a?.created_at) - new Date(b?.created_at)
                if (dateComparison === 0) {
                    return a?.vehicle_name.localeCompare(b?.vehicle_name)
                }
                return dateComparison
            })

            dispatch(setFilteredVehicles({ ...response?.data, records: sortedData }))
            setFilters(response?.data)
            setTotalSummary(response?.data?.totalSummary)

            if (response?.data?.dateRange?.startDate && response?.data?.dateRange?.endDate) {
                const startDate = moment(response?.data?.dateRange?.startDate, dateFormate)
                const endDate = moment(response?.data?.dateRange?.endDate, dateFormate)

                setDateRange([startDate, endDate])
                form.setFieldsValue({ dateRange: [startDate, endDate] })
            }
        } else {
            // console.error('Failed to fetch last week data:', response?.data?.message)
        }
    } catch (error) {
        // console.error('Error fetching last week data:', error)
    }
}

const fetchOrganization = async ({ setOrganizationsData, setOrganizations, dispatch, currentPage, pageSize, setTotalRecords, searchQuery }) => {
    try {
        const page = Number(currentPage) > 0 ? Number(currentPage) : 1
        const limit = Number(pageSize) > 0 ? Number(pageSize) : 10

        const response = await secureApi?.get(GET?.GET_ORGANIZATIONS, {
            params: {
                page, limit, searchQuery: searchQuery,
            }
        })
        // console.log(response)
        if (response?.success === true) {
            const organizations = response?.data
            setTotalRecords(response?.total || 0)
            dispatch(setOrganizationsData(organizations))
            // console.log(organizations)
            setOrganizations(organizations)
        } else {
            setTotalRecords(0)
            // console.log("API response did not return success:", response)
        }
    }
    catch (err) {
        // console.error("Error fetching organizations:", err)
    }
}

const fetchAllOrganization = async ({ dispatch }) => {
    try {
        const response = await secureApi?.get(GET?.GET_ALL_ORGANIZATIONS)
        // console.log(response)
        if (response?.success === true) {
            const organizations = response?.data
            dispatch(setAllOrganizationsData(organizations))
            // console.log(organizations)
        } else {
            // console.log("API response did not return success:", response)
        }
    }
    catch (err) {
        // console.error("Error fetching organizations:", err)
    }
}

const fetchMonthStats = async ({ user, organizationId, dispatch, setMonthStats }) => {
    try {
        const user_id = user?.id
        const response = await secureApi?.get(`${GET?.GET_MONTH_STATS}?user_id=${user_id}&organization_id=${organizationId}`)
        if (response?.success) {
            dispatch(setMonthStats(response?.data))
        } else {
        }
    } catch (error) {
        console.error('Error fetching monthly stats:', error)
    }
}
const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    })
}

const downloadPeopleReport = async ({ records, elmecLogoImage, isSuperAdmin, language }) => {
    try {
        const response = await secureApi?.post(
            `${POST?.DOWNLOAD_PEOPLE_COUNTER_PDF}`,
            { records, elmecLogoImage, isSuperAdmin, language }
        )
        // console.log(response, 'response in downloadPeopleReport')
        const base64String = response?.data?.data || response?.data

        if (!base64String?.startsWith('data:application/pdf;base64,')) {
            console.error('Invalid PDF response:', response)
            message.error('No valid PDF returned from server')
            return
        }

        const base64Data = base64String.split(',')[1]
        const byteCharacters = atob(base64Data)
        const byteNumbers = Array.from(byteCharacters).map(c => c.charCodeAt(0))
        const byteArray = new Uint8Array(byteNumbers)

        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Passenger_Summary_Report.pdf')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
    } catch (err) {
        console.error('Report download failed:', err)
        message.error(translations[language]?.pdfDownloadFail)
    }
}

const downloadVehicleReport = async ({ records, elmecLogoImage, isSuperAdmin, language, organizationDetails, user, setDownloadLoading }) => {
    try {
        if (setDownloadLoading) setDownloadLoading(true)
        const response = await secureApi?.post(POST?.DOWNLOAD_VEHICLE_REPORT_PDF, {
            input: records,
            language,
            organizationDetails,
            user,
            elmecLogoImage,
            isSuperAdmin,
        }
        )

        const base64String = response?.data?.data || response?.data

        if (!base64String?.includes('base64,')) {
            console.error('Invalid PDF response:', response)
            message.error('No valid PDF')
            return
        }

        const base64Data = base64String.split('base64,')[1]
        const byteArray = new Uint8Array(atob(base64Data).split('').map(char => char.charCodeAt(0)))

        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const url = URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.download = 'Vehicle_Summary_Report.pdf'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        message.success(translations[language]?.pdfDownloadSuccess)
    } catch (err) {
        console.error('Report download failed:', err)
        message.error(translations[language]?.pdfDownloadFail)
    }
    finally {
        if (setDownloadLoading) setDownloadLoading(false);
    }
}

const fetchSerialNumbers = async ({ setAvailableSerialNumbers, dispatch, selectedRouterType }) => {
    try {
        const routerType = selectedRouterType.toLowerCase()
        const response = await secureApi?.get(GET?.GET_AVAILABLE_SERIAL_NUMBER, {
            params: { router_type: routerType }
        })
        // console.log(response, 'response in fetchSerialNumbers')
        if (response?.success) {
            dispatch(setAvailableSerialNumbers(response?.data))
        } else {
            dispatch(setAvailableSerialNumbers([]))
        }

    }
    catch (error) {
        // console.error('Error fetching serial numbers:', error)
        dispatch(setAvailableSerialNumbers([]))
    }
}

function haversineDistance(lat1, lng1, lat2, lng2) {
    const R = 6371000; // meters
    const toRad = deg => deg * Math.PI / 180;
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) *
        Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

function dedupeClosePoints(points, minDistanceMeters = 10) {
    const result = [points[0]];
    for (let i = 1; i < points.length; i++) {
        const prev = result[result.length - 1];
        const curr = points[i];
        const dist = haversineDistance(prev.lat, prev.lng, curr.lat, curr.lng);
        if (dist >= minDistanceMeters) result.push(curr);
    }
    return result;
}

const getOSRMRoute = async (polyline) => {
    if (!polyline || polyline.length === 0) {
        console.warn('Empty polyline input');
        return [];
    }

    const pathString = polyline.map(p => `${p.lng},${p.lat}`).join(';');
    const url = `https://map.elmecelettronica.com/route/v1/driving/${pathString}?overview=full&geometries=geojson`;

    try {
        const response = await fetch(url);
        const data = await response.json();

        if (data.code !== 'Ok' || !data.routes?.[0]) {
            console.error('OSRM routing failed:', data);
            return [];
        }

        const coordinates = data.routes[0].geometry.coordinates.map(([lng, lat]) => ({
            lat,
            lng,
        }));

        return dedupeClosePoints(coordinates);
    }
    catch (err) {
        console.error('OSRM fetch error:', err);
        return [];
    }
}

const fetchUnassociatedVehicle = async ({ setUnassociatedVehicles, organizationId, device_type, selectOrgFilter, user }) => {
    try {
        const role = user?.role
        // console.log(role, 'role in fetchUnassociatedVehicle')
        // console.log(selectOrgFilter, 'selectOrgFilter in fetchUnassociatedVehicle')
        const orgId = role === 'superAdmin' ? selectOrgFilter : organizationId
        // console.log(orgId, 'orgId in fetchUnassociatedVehicle')
        const response = await secureApi?.get(`${GET?.GET_UNASSOCIATED_VEHICLE}?organization_id=${orgId}&device_type=${device_type}`)
        // console.log(response, 'response')
        if (response?.success) {
            setUnassociatedVehicles(response?.data || [])
        } else {
            setUnassociatedVehicles([])
        }
    } catch (err) {
        // console.error('fetch error:', err)
        return []
    }
}

const getDisabledTime = (current) => {
    if (!current || !current.isSame(moment(), 'day')) return {}
    const now = moment()
    return {
        disabledHours: () =>
            Array.from({ length: 24 }, (_, i) => i).filter((h) => h > now.hour()),
        disabledMinutes: (selectedHour) =>
            selectedHour === now.hour()
                ? Array.from({ length: 60 }, (_, i) => i).filter((m) => m > now.minute())
                : [],
        disabledSeconds: (selectedHour, selectedMinute) =>
            selectedHour === now.hour() && selectedMinute === now.minute()
                ? Array.from({ length: 60 }, (_, i) => i).filter((s) => s > now.second())
                : []
    }
}

export {
    fetchUsers,
    fetchDevices,
    fetchVehicles,
    verifyToken,
    requiredMessage,
    inputPlace,
    setActiveMenu,
    successMessage,
    infoMessage,
    errorMessage,
    warningMessage,
    successNotification,
    errorNotification,
    convertTitle,
    stringLimiter,
    formatDate,
    handleLogout,
    fetchLastWeekData,
    fetchOrganization,
    getBase64,
    downloadVehicleReport,
    fetchMonthStats,
    fetchAllOrganization,
    downloadPeopleReport,
    fetchSerialNumbers,
    getOSRMRoute,
    fetchUnassociatedVehicle,
    fetchBusLed,
    fetchLinesDirections,
    fetchLines,
    getDisabledTime,
    vehicleLabel
}